<template>
	<div>
	<CreateMapEditor 
        :canDraw="canDraw" 
        :widthStyle="true" 
        :canEditPolygon="canEditPolygon"
        :canEditAndInteract="false"
        :detailsAreaPanelActive="true"
        :reviewAreaPanelActive="false"
    />
	<div id="createAreaDetailsPanel" :class="{active: true}">
		<button class="details-panel__close" @click="closeAreaDetailsPanel">X</button>
		<div class="panel details-panel__header">
			<div class="col md-12">
				<h1 class="details-panel__header__title">{{areaData.areaTitle}}</h1>
			</div>
			<div class="data__subtitle__wrap">
				<div class="data__subtitle--dark">{{maContent.ma5_1_1}}</div>
				<div class="details-panel__header__areaSqm">{{areaData.areaSquared.toLocaleString('en')}}&nbsp;sqm</div>
			</div>
			<div class="data__subtitle__wrap">
				<div class="data__subtitle--dark">{{maContent.ma5_1_2}}</div>
				<div class="details-panel__header__desc">{{areaData.areaDescription | truncate(160) }}</div>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="space-footer-panel">
		<div class="panel__options">
			<div class="col md-12">
				<div class="panel__options__checkbox">
					<input type="checkbox" v-model="plan.serviceOption1"> 
					<span>{{maContent.ma5_2_1}}</span><div class="panel__options__checkbox-top__desc"> <p> {{maContent.ma5_2_1_1}}</p></div> 
					<button class="modal--info" v-if="maContent.maO_4 == true" @click="openModal('serviceOption1Modal')"></button>
				</div>
				<div class="panel__options__checkbox">
					<input type="checkbox" v-model="plan.serviceOption2">
					<span>{{maContent.ma5_2_2}}</span><div class="panel__options__checkbox-top__desc"> <p> {{maContent.ma5_2_2_1}}</p></div> 
					<button class="modal--info" v-if="maContent.maO_4 == true" @click="openModal('serviceOption2Modal')"></button>
				</div>
				<div class="panel__options__checkbox">
					<input type="checkbox" v-model="plan.serviceOption3">
					<span>{{maContent.ma5_2_3}}</span><div class="panel__options__checkbox-top__desc"> <p> {{maContent.ma5_2_3_1}}</p></div> 
					<button class="modal--info" v-if="maContent.maO_4 == true" @click="openModal('serviceOption3Modal')"></button> 
				</div>
				<div class="panel__options__checkbox">
					<input type="checkbox" v-model="plan.serviceOption4">
					<span>{{maContent.ma5_2_4}}</span><div class="panel__options__checkbox-top__desc"> <p> {{maContent.ma5_2_4_1}}</p></div> 
					<button class="modal--info" v-if="maContent.maO_4 == true" @click="openModal('serviceOption4Modal')"></button>
				</div>
				<div class="panel__options__checkbox">
					<input type="checkbox" v-model="plan.serviceOption5">
					<span>{{maContent.ma5_2_5}}</span><div class="panel__options__checkbox-top__desc"> <p> {{maContent.ma5_2_5_1}}</p></div> 
					<button class="modal--info" v-if="maContent.maO_4 == true" @click="openModal('serviceOption5Modal')"></button>
				</div>
			</div>
		</div>	
		
			
		<div class="panel panel__detail">
			<div class="panel__additional-detail">
				<div class="col md-3">
					<div class="panel__info"></div>
				</div>

				<div class="col md-9">
					<div class="list-additional-details" v-if="plan.additionalDetails">
						<div class="additional-detail" v-for="(detail, index) in plan.additionalDetails" :key="index">
							<span class="additional-detail__close" @click="removeAdditionalDetail(index)"></span><span>{{detail}}</span>
						</div>
					</div>
					<div class="clearfix"></div>
						<div class="add-addtional-details">
						<input type="text" v-model="detailInput" @keydown.enter="addAdditionalDetail" v-bind:placeholder="maContent.ma5_3_1" class="addtional-details-input">
						<button class="add-addtional-details__enter" @click="addAdditionalDetail"></button>
					</div>
				</div>
				<div class="clearfix"></div>
			</div>
		</div>

		<div class="panel panel__options">
			<div class="col md-12">
				<div class="panel__options__upload-wrap">
					<p class="form-subhead">{{maContent.ma5_4_1}}</p> <button class="modal--info" @click="openModal('UploadingFileModal')"></button>
						<div class="panel__options__checkbox">
							<input type="checkbox" @change="userUploadChanger" :checked="plan.userUpload === false"> 
								<span>{{maContent.ma5_4_2}}</span>
						</div>
							<!-- <input type="file" @change="handleFileChange" :disabled="plan.userUpload !== false" name="existingSurveyPdf"> -->
							<div v-if="plan.userUpload === false"><input type="file" @change="handleFileChange" name="existingSurveyPdf"></div>
				</div>
			</div>
			<div class="clearfix"><br></div>
			<div class="clearfix"></div>
			<div class="clearfix"></div>
		</div>	
		</div>
		<div class="panel panel__bottom">
			<div class="next-block-buttons">
				<div class="next-block__area-data col md-5">
					<div class v-if="totalArea >0.1">
					<div class="next-block__total-area-data">Total Area - {{totalArea | currency('', 0)}} sqm</div>
					</div>
					<div class="next-block__saved-areas">{{savedAreas.length}} {{maContent.ma5_5_1}}</div>
					
				</div>

				<div class="continue-area col md-4">
					<button class="primary" @click="saveArea">Continue</button>
				</div>

			    <div class="cancel-area col md-3">
					<a @click="closeAreaDetailsPanel">Cancel</a>
				</div>				
			</div>
		</div>

	</div>
	</div>
</template>

<script>
	import objectToFormData from 'object-to-formdata'; 
	import CreateMapEditor from '../common/Create/CreateMapEditor';

	export default {
		components : {
			CreateMapEditor : CreateMapEditor
		},
		data(){
			
			return {
				canDraw : null,
            	canEditPolygon : false,
				detailInput : '',
				plan : {
					additionalDetails : [],
					userUpload : true,
					existingSurveyPdf : undefined,
					serviceOption1: undefined,
					serviceOption2: undefined,
					serviceOption3: undefined,
					serviceOption4: undefined,
					serviceOption5: undefined,
					serviceOption6: undefined,
					serviceOption7: undefined,
					serviceOption8: undefined,
					serviceOption9: undefined,
					serviceOption10: undefined
				},
				
			}
		},
		computed : {
			areaData(){
				return this.$store.getters.areaCreatorData
			},
			savedAreas(){
				return this.$store.getters.savedAreas;
			},
			totalArea(){
				let areas = this.savedAreas

				if(areas.length == 0){
					return;
				}

				let reducedObj = areas.reduce(function (a, b) {
				 
				  return {areaSquared: a.areaSquared + b.areaSquared}; // returns object with property x
				})

				return reducedObj.areaSquared;
			},
			maContent(){
				return this.$store.getters.getBuildData;
				},
		},
		methods : {
			closeAreaDetailsPanel(){
				this.$store.commit('navigateToSelectArea');
			},

			openModal(modalName){
				console.log('fired', modalName);
				this.$store.commit('openModal', modalName)
				
			},

			addAdditionalDetail(e){
				
				if(this.detailInput.length < 1){
					return
				}

				if(this.plan.additionalDetails.length >= 15){
					this.$toasted.show('You can only enter a maximum of 15 additional Details', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
                    return;
				}

				this.plan.additionalDetails.push(this.detailInput);
				this.detailInput = "";
				console.log('details', this.detailInput);
			},

			
					
			changePresentationPlan(e){
				this.plan.presentationOptions = e.target.value;
			},

			changeBaseMappingPlan(e){
				this.plan.baseMapping = e.target.value;
			},

			userUploadChanger(e){
				this.plan.userUpload = !this.plan.userUpload;
			},

			handleFileChange(e){
				var file = e.target.files[0]; 
				this.plan.existingSurveyPdf = file;
			},

			removeAdditionalDetail(index){
				this.plan.additionalDetails.splice(index, 1);
			},

			saveArea(){
				
				// Checks if Upload is checked on Grid & Height Option
				if(this.plan.existingSurveyPdf === undefined && this.plan.userUpload == false){
					this.$toasted.show('You selected to upload an a file but you did not upload a file', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
                    return;
				}
				const otherData = Object.assign({}, this.areaData);
				const planData = Object.assign({}, this.plan);
				const preForm = {...otherData, ...planData};
				preForm.kmlCoordinates = JSON.stringify(preForm.kmlCoordinates);
			
				const formData = objectToFormData(preForm);
				
				this.$store.dispatch('CREATE_AREA', formData)
				.then((data) => {
					
					this.$toasted.clear();
					if(data.confirmation !== 'success'){
						this.$toasted.error('Looks like something went wrong, please contact us and we will try to resolve this. Error message:', {
	                        theme: 'bubble',
	                        position: 'bottom-center',
	                        duration: 5000
	                    })
	                    return;
					} else {
						this.$toasted.success('Success', {
	                        theme: 'bubble',
	                        position: 'bottom-center',
	                        duration: 5000
	                    })
	                    this.activePlanType = "band2";
	                    this.plan = {
	                    	userUpload : true,
							existingSurveyPdf : undefined,
							serviceOption1: undefined,
							serviceOption4: undefined,
							serviceOption3: undefined,
							serviceOption4: undefined,
							serviceOption5: undefined,
							serviceOption6: undefined,
							serviceOption7: undefined,
							serviceOption8: undefined,
							serviceOption9: undefined,
							serviceOption10: undefined
	                    }
					}
				})
				.catch((err) => {
					
					this.$toasted.clear();
					this.$toasted.error('Looks like something went wrong, please contact us and we will try to resolve this.', {
	                        theme: 'bubble',
	                        position: 'bottom-center',
	                        duration: 5000
						})
						
						// console.log(err);
	                    return;
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateAreaDetailsPanel.vue